// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    // loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.sp-swiper-btn-next',
      prevEl: '.sp-swiper-btn-prev',
    },
  })

  const swiper1 = new Swiper('.sp-swiper2', {
    autoplay: {
      disableOnInteraction: false,
      delay: 2500,
    },
    spaceBetween: 0,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
    on: {
      slideChange: function () {
        // 获取对应的sp-content
        const spContent = document.querySelector(
          '.sp-part7 .sp-size-box .sp-content:not([style*="top"])'
        )
        if (spContent) {
          // 移除所有active类
          const items = spContent.querySelectorAll('div')
          items.forEach(item => item.classList.remove('active'))
          // 给当前索引的项添加active类
          const currentIndex = this.realIndex
          if (items[currentIndex]) {
            items[currentIndex].classList.add('active')
          }
        }
      },
    },
  })

  const firstSpContent = document.querySelector(
    '.sp-part7 .sp-size-box .sp-content:not([style*="top"])'
  )
  if (firstSpContent) {
    const buttons = firstSpContent.querySelectorAll('div')
    buttons.forEach((button, index) => {
      button.addEventListener('click', function () {
        // 移除所有active类
        buttons.forEach(btn => btn.classList.remove('active'))
        // 添加active类到当前按钮
        this.classList.add('active')
        // 切换到对应的slide
        swiper1.slideTo(index)
      })
    })
  }

  const swiper2 = new Swiper('.sp-swiper3', {
    autoplay: {
      disableOnInteraction: false,
      delay: 2500,
    },
    spaceBetween: 0,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        // 初始化时设置第一个按钮为active
        const spContent = document.querySelector(
          '.size-pop .sp-size-box .sp-content:not([style*="top"])'
        )
        if (spContent) {
          const items = spContent.querySelectorAll('div')
          items.forEach(item => item.classList.remove('active'))
          if (items[0]) {
            items[0].classList.add('active')
          }
        }
      },
      slideChange: function () {
        // 获取对应的sp-content
        const spContent = document.querySelector(
          '.size-pop .sp-size-box .sp-content:not([style*="top"])'
        )
        if (spContent) {
          // 移除所有active类
          const items = spContent.querySelectorAll('div')
          items.forEach(item => item.classList.remove('active'))
          // 给当前索引的项添加active类
          const currentIndex = this.realIndex
          if (items[currentIndex]) {
            items[currentIndex].classList.add('active')
          }
        }
      },
    },
  })

  const firstSpContent2 = document.querySelector(
    '.size-pop .sp-size-box .sp-content:not([style*="top"])'
  )
  if (firstSpContent2) {
    const buttons = firstSpContent2.querySelectorAll('div')
    buttons.forEach((button, index) => {
      button.addEventListener('click', function () {
        // 移除所有active类
        buttons.forEach(btn => btn.classList.remove('active'))
        // 添加active类到当前按钮
        this.classList.add('active')
        // 切换到对应的slide
        swiper2.slideTo(index)
      })
    })
  }

  $('.reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
  })
  $('.add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
  })

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - 255
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  // 获取images元素
  const images = document.querySelectorAll('.slider-images img')

  // 设置初始索引
  let imageIndex = 0

  // 获取前一个image的索引
  function getPrevImageIndex() {
    return (imageIndex - 1 + images.length) % images.length
  }

  // 获取下一个image的索引
  function getNextImageIndex() {
    return (imageIndex + 1) % images.length
  }

  // 更新 slider
  function updateSlider() {
    // 获取前一个image的索引
    let prevImageIndex = getPrevImageIndex()
    // 获取下一个image的索引
    let nextImageIndex = getNextImageIndex()

    // 从images数组中删除所有的active, previous, next, inactive类
    images.forEach(image => {
      image.classList.remove('active', 'previous', 'next', 'inactive')
    })

    // 当前image元素增加active类
    images[imageIndex].classList.add('active')

    // 对前一个image元素增加previous类
    images[prevImageIndex].classList.add('previous')

    // 对后一个image元素增加next类
    images[nextImageIndex].classList.add('next')

    // 对于其他的image元素, 增加inactive类
    images.forEach((image, index) => {
      if (
        index !== imageIndex &&
        index !== prevImageIndex &&
        index !== nextImageIndex
      ) {
        image.classList.add('inactive')
      }
    })

    // 更新image索引
    imageIndex = nextImageIndex

    $('.sp-group .sp-p')
      .eq(imageIndex - 1)
      .addClass('sp-active')
      .siblings()
      .removeClass('sp-active')
  }

  // 立即更新
  updateSlider()
  // 定时更新
  setInterval(updateSlider, 3000)

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-detail')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 2s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 2s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 2s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
}

mainRender()

let spImgList = [
  'https://cdn.shopify.com/s/files/1/0733/4825/1959/files/20251011-t1.png',
  'https://cdn.shopify.com/s/files/1/0733/4825/1959/files/20251011-t2.png',
  'https://cdn.shopify.com/s/files/1/0733/4825/1959/files/20251011-t3.png',
  'https://cdn.shopify.com/s/files/1/0733/4825/1959/files/20251011-t4.png',
  'https://cdn.shopify.com/s/files/1/0733/4825/1959/files/20251011-t5.png',
]
// 展示尺码弹窗
$('.sp-size-btn').click(function () {
  $('.sp-mask').css('display', 'flex')
  $('.sp-mask .size-pop').show()
  $('.sp-mask .img-pop').hide()
})

// 关闭弹窗按钮
$('.sp-mask').click(function (e) {
  if ($(e.target).closest('.sp-mask .choose-btn').length > 0) {
    // 点击选择按钮不关闭
  } else if ($(e.target).closest('.size-pop').length > 0) {
    // 点击 size-pop 内部，只有点击 sp-close 才关闭
    if ($(e.target).closest('.sp-close').length > 0) {
      $('.sp-mask').hide()
    }
  } else if ($('.size-pop').is(':visible')) {
    // 如果 size-pop 正在显示，点击遮罩层不关闭
    return
  } else {
    // 如果 img-pop 正在显示，点击遮罩层关闭弹窗
    $('.sp-mask').hide()
  }
})

$('.sp-reduce').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) - 1
  if (num > 0) {
    input.value = num
    changePrice()
  }
})
$('.sp-add').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) + 1
  input.value = num
  changePrice()
})

$('.option').click(function () {
  $(this).siblings().removeClass('active')
  $(this).addClass('active')
  // style选项

  let colorOptions = $('#sp-color .option.active').index()
  let img0 = $('.product-part .p-img')

  img0[0].src = spImgList[colorOptions]
  swiper.slideTo(colorOptions)
})
// 双购物部分处理
let spShopIndex = 0
$('.sp-check').click(function () {
  $(this).addClass('active').siblings().removeClass('active')
  spShopIndex = $(this).index()
  if (spShopIndex == 0) {
    $('.sp-index1').show()
    $('.sp-index2').hide()
    $('.sp-img1').show()
    $('.sp-img2').hide()
  } else {
    $('.sp-index1').hide()
    $('.sp-index2').show()
    $('.sp-img1').hide()
    $('.sp-img2').show()
  }
  changePrice()
  $('#calcNumber').val(1)
})

// 点击放大按钮
$('.sp-large,.p-img').click(function () {
  $('.sp-mask').css('display', 'flex')
  let _img
  if (spShopIndex == 0) {
    _img = $('#swiper-p1 .swiper-slide-active .sp-img')
    _img
    $('.sp-mask .img-pop .sp-img')[0].src = _img[0].srcset
  } else {
    _img = $('.product-part .sp-index2 .p-img')
    $('.sp-mask  .img-pop  .sp-img')[0].src = _img[0].src
    $('.sp-mask  .img-pop  .sp-img')[1].src = _img[1].src
  }

  $('.sp-mask .img-pop').css('display', 'flex')
  $('.sp-mask .size-pop').hide()
})

let colorList = ['Brown', 'Burgundy', 'Navy', 'Black', 'White']
let modelList = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL']
// 模拟select-option
$('.sp-select').click(function () {
  $(this).siblings('.select-opt').toggle()
})

$('.select-opt li').click(function () {
  let spimg = $('.product-part .sp-index2 .p-img')
  let _index = $(this).index()
  let _color = $(this).attr('data-color')
  let _parent = $(this).parent().parent().siblings('.sp-select')
  if (_parent.attr('data-type') == 'spColor1') {
    _parent.html(
      `<span style="background: ${_color}"></span>${colorList[_index]}`
    )
    spimg[0].src = spImgList[_index]
  } else if (_parent.attr('data-type') == 'spColor2') {
    _parent.html(
      `<span style="background: ${_color}"></span>${colorList[_index]}`
    )
    spimg[1].src = spImgList[_index]
  } else {
    _parent.text(modelList[_index])
  }
  $(this).siblings().removeClass('active')
  $(this).addClass('active')
  $('.select-opt').hide()
})

let prods = window.product
function getCur() {
  let color = $('#sp-color div.active').attr('data-val')
  let size = $('#sp-size div.active').attr('data-val')
  return prods.filter(item => item.option1 == color && item.option2 == size)[0]
}
function getProdictId1() {
  let color = $('.select-color1 li.active').attr('data-val')
  let size = $('.select-size1 li.active').attr('data-val')
  console.log('color', color)
  console.log('size', size)
  return prods.filter(item => item.option1 == color && item.option2 == size)[0]
}
function getProdictId2() {
  let color = $('.select-color2 li.active').attr('data-val')
  let size = $('.select-size2 li.active').attr('data-val')
  return prods.filter(item => item.option1 == color && item.option2 == size)[0]
}
function changePrice() {
  let num = $('#calcNumber').val()
  let price = ((getCur().price * num) / 100).toFixed(2)
  let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  let index = $('.sp-check-btn div.active').index()
  if (index == 1) {
    price = price * 2
    compare = compare * 2
  }
  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  // $(".product-part .price-group .sp-row span").html(off_font);
}
$('.sp-btn-style').click(function () {
  let num = $('#calcNumber').val()
  let index = $('.sp-check-btn div.active').index()
  if (index == 0) {
    window.location.href = '/cart/' + getCur().id + ':' + num
  } else {
    console.log('getProdictId1', getProdictId1())
    window.location.href =
      '/cart/' +
      getProdictId1().id +
      ':' +
      num +
      ',' +
      getProdictId2().id +
      ':' +
      num
  }
})

// 购物车加购动效
$('.cart-btn').click(function () {
  let index = $('#swiper-p1 .swiper-slide-active').index()
  //   if (index == 0) return
  $(this).children('img').addClass('on')
  $('.sp-header-top .sp-cart .num').show()
  setTimeout(function () {
    $('.cart-btn').children('img').removeClass('on')
  }, 500)
  $('.sp-header-top .sp-cart').addClass('on')
  setTimeout(function () {
    $('.sp-header-top .sp-cart').removeClass('on')
  }, 500)
})
$('.product-part .cart-btn').click(function () {
  var img
  if (spShopIndex == 0) {
    let index = $('#swiper-p1 .swiper-slide-active').index()
    img = $('#swiper-p1 .swiper-slide-active .sp-img')
    let number = Number($('#cardNum').html())
    let input = Number($('#calcNumber').val())
    $('#cardNum').html(number + input)

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          // $("#cardNum").html(result.item_count);
        })
      },
      dataType: 'json',
    })
  } else {
    img = $('.product-part .sp-index2 .p-img')
    let number = Number($('#cardNum').html())
    let input = Number($('#calcNumber').val()) * 2
    $('#cardNum').html(number + input)

    let formData = {
      items: [
        { id: getProdictId1().id, quantity: $('#calcNumber').val() },
        { id: getProdictId2().id, quantity: $('#calcNumber').val() },
      ],
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then(response => {
        return response.json()
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }
  var flyer = img[0].cloneNode(true)
  flyer.classList.add('sp_clone')
  $('.product-part').append(flyer)
  $('.sp_clone').css({
    width: img[0].width,
    height: img[0].height,
    background: '#F1F1F3',
    position: 'fixed',
    top: img[0].offsetTop,
    left: img.offset().left,
    'z-index': '99',
  })
  let finish = $('.sp-cart')
  $('.sp_clone').animate(
    {
      top: finish[0].offsetTop + $('.time-part').height(),
      left: finish[0].offsetLeft + finish.width() / 2,
      width: 50, // 结束时的大小，根据需要调整
      height: 50, // 结束时的大小，根据需要调整
      opacity: 0.4,
    },
    500,
    'linear',
    function () {
      $(this).animate(
        {
          width: 0,
          height: 0,
          opacity: 0,
        },
        0,
        function () {
          $(this).detach()
        }
      )
    }
  )
  // 另一个
  if (spShopIndex == 1) {
    var img2
    img2 = $('.product-part .sp-index2 .p-img2')
    var flyer2 = img2[0].cloneNode(true)
    flyer2.classList.add('sp_clone2')
    $('.product-part').append(flyer2)
    $('.sp_clone2').css({
      width: img2[0].width,
      height: img2[0].height,
      position: 'fixed',
      background: '#FAF4EE',
      top: img2[0].offsetTop,
      left: img2.offset().left,
      'z-index': '99',
    })
    $('.sp_clone2').animate(
      {
        top: finish[0].offsetTop + $('.time-part').height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      'linear',
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach()
          }
        )
      }
    )
  }
})

let swiper = new Swiper('#swiper-p1', {
  on: {
    slideChange: function (e) {
      $('#sp-color .option')
        .eq(e.activeIndex)
        .addClass('active')
        .siblings()
        .removeClass('active')
    },
  },
  speed: 1,
  spaceBetween: 20,
})
